function TablePagination(): any {
  return {
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          fontSize: '0.875rem'
        },
        toolbar: {
          paddingRight: '16px !important'
        },
        displayedRows: {
          fontSize: '0.875rem'
        }
      }
    }
  };
}

export { TablePagination };
